window.addEventListener("DOMContentLoaded", () => {
  const sections = document?.querySelectorAll(".collections-slider");
  sections?.forEach((item) => {
    const slidesWrapper = item?.querySelector(".slider-wrapper");
    if (slidesWrapper) {
      const flkty = new Flickity(slidesWrapper, {
        pageDots: false,
        prevNextButtons: false,
        cellAlign: "left",
        watchCSS: true,
      });
    }
  });
});
